import {
Component,
Injector,
Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";
import {FormsModule} from "@angular/forms";

const DEFAULT_CLS = 'input-group app-colorpicker';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-colorpicker',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmColorpicker]',
  template: `
    <input class="form-control app-textbox" aria-haspopup="true" aria-expanded="false"
           #input
           focus-target
           [attr.name]="name"
           [attr.aria-label]="hint || 'Colorpicker'"
           [attr.placeholder]="placeholder"
           [disabled]="readonly || disabled"
           [required]="required"
           [tabindex]="tabindex"
           [(ngModel)]="datavalue"
           [attr.accesskey]="shortcutkey">
    <span class="input-group-addon colorpicker-container">
    <i class="colored-box" [style.backgroundColor]="datavalue">&nbsp;</i>
</span>
  `,
  providers: [
    provideAsWidgetRef(ColorpickerComponent)
  ],
  exportAs: 'wmColorpicker',
  standalone: true,
  imports: [CommonModule, FormsModule],
  styles: []
})
export class ColorpickerComponent extends StylableComponent {
  static initializeProps = register('wm-colorpicker');

  public required: boolean;
  public readonly: boolean;
  public disabled: boolean;
  public name: string;
  public placeholder: any;
  public tabindex: any;
  public shortcutkey: string;
  public outsideclick: boolean;
  public autoclose: string;
  public hint: string;
  public _datavalue: string
  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

  get datavalue() {
    return this._datavalue;
  }
  set datavalue(val: string) {
    this._datavalue = val;
  }
}

